import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import MembershipActivationButton from '../../../components/MembershipActivationButton';

const CourseMembershipRequiredBanner = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <Card sx={{ 
        backgroundColor: 'warning.main', 
        border: '1px solid #002366', 
        boxShadow: 1, 
        borderRadius: 2, 
        p: 2, 
        display: 'flex', 
        alignItems: { xs: 'flex-start', sm: 'center' }, 
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' }
      }}>
        <Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' } }}>
          <Typography variant='subtitle1' color='white' fontWeight={600}>
            Alcuni corsi potrebbero richiedere un tesseramento, attivane uno.
          </Typography>
        </Box>
        <MembershipActivationButton 
          variant='contained'
          sx={{ 
            fontWeight: 700, 
            borderRadius: 2, 
            bgcolor: 'white', 
            color: 'primary.main', 
            '&:hover': { bgcolor: 'grey.100' },
            '&:disabled': {
              bgcolor: 'grey.300',
              color: 'grey.500'
            },
            width: { xs: '100%', sm: 'auto' },
            minWidth: { xs: 'auto', sm: '120px' }
          }}
          autoFetch={true}
        />
      </Card>
    </Box>
  );
};

export default CourseMembershipRequiredBanner;
